if (!customElements.get('banner-image-component')) {
  class BannerImageComponent extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.container = this.closest('[data-section-type]');
      this.handleImageAnimation();

      const title = this.querySelector('[data-banner-title]');
      if (title && !title.classList.contains('text-highlight-wrapper')) {
        const animatedElement = title.querySelector('[data-aos]');
        if (!animatedElement) return;

        const cropper = animatedElement.closest('.text-reveal__cropper');
        if (cropper) {
          cropper.classList.add('overflow-hidden');
          window.theme.waitForAnimationEnd(animatedElement).then(() => {
            cropper.classList.remove('overflow-hidden');
          });
        }
      }
    }

    handleImageAnimation() {
      const imageContainer = this.querySelector('[data-banner-image]');
      if (!imageContainer) return;

      const images = imageContainer.querySelectorAll('.lazy-image');
      const isImgIn = this.container.classList.contains('img-in');

      if (!images.length || isImgIn) return;

      // New: detect if this banner is the LCP hero
      const isLcpHero = this.container.classList.contains('banner-image--lcp-hero');

      this.container.classList.add('banner--no-cached-images');

      const markLoaded = () => {
        requestAnimationFrame(() => {
          this.container.classList.add('banner--img-loaded');
        });
      };

      if (isLcpHero) {
        // For the primary hero banner (likely LCP), mark as loaded immediately
        // so Lighthouse doesn't wait for the end of the image transition.
        markLoaded();
        return;
      }

      const firstImage = images[0];

      const onTransitionEnd = () => {
        markLoaded();
        firstImage.removeEventListener('transitionend', onTransitionEnd);
      };

      firstImage.addEventListener('transitionend', onTransitionEnd);
    }
  }

  customElements.define('banner-image-component', BannerImageComponent);
}